<template>
  <el-dialog
    :visible="visible"
    custom-class="sell-sincerity-box"
    top="10vh"
    width="1157px"
    :show-close="false"
    :append-to-body="true"
  >
    <div class="main">
      <div class="top">
        <div>诚心卖服务说明</div>
        <span @click="$emit('update:visible',false)">返回</span>
      </div>
      <div class="bottom">
        <div v-html="content"></div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'sellSincerityDia',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-dialog{
  border-radius: 4px !important;
}
/deep/.el-dialog__header {
  display: none !important;
}

/deep/.el-dialog__body {
  padding: 0 !important;
  border-radius: 4px !important;
}
.sell-sincerity-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  max-height: 660px;
  background: transparent;
  .main{
    max-width: 1157px;
    .top{
      box-sizing: border-box;
      background: url('../../../assets/image/AccountDeal/sellSincerityTop.png') no-repeat;
      background-size: 100%;
      width: 100%;
      height: 92px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 26px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      padding: 0 40px;
      span{
        font-size: 20px;
        cursor: pointer;
      }
    }
    .bottom{
      min-height: 718px;
      padding: 40px;
    }
  }
}
</style>